import React, { useEffect, useState } from 'react';

import { Box, Grid, Typography, useMediaQuery, Modal, Button } from '@mui/material';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import OndemandVideoOutlinedIcon from '@mui/icons-material/OndemandVideoOutlined';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { AVAILABLE_COUNTRY, COLOR_PRIMARY, COLOR_PRIMARY_DARK } from 'src/const';
import { COLOR_GREY_600, COLOR_PRIMARY_1, COLOR_PRIMARY_1_800, COLOR_PRIMARY_2 } from 'src/colors';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

const IndividualOnBoardingPage = ({
  SearchBox,
  onSamplePageClick,
  onVideoClick,
  cover,
}: {
  SearchBox: (isOnboardingOn: boolean) => JSX.Element;
  onSamplePageClick: () => void;
  onVideoClick: () => void;
  cover: string;
}) => {
  const userCountryCode = useSelector(state => (state as any).dashboard.userCountryCode);
  const isMobile = useMediaQuery('(max-width:899.5px)');
  const history = useHistory();

  const [isMobileSearchModalOpen, setIsMobileSearchModalOpen] = useState<boolean>(false);

  return (
    <>
      {/* <img
        src={cover}
        style={{
          width: '100%',
          height: 750,
          position: 'absolute',
          top: 0,
          left: 0,
          objectFit: 'cover',
        }}
      /> */}
      <div
        style={{
          width: '100%',
          height: '95vh',
          position: 'absolute',
          top: 0,
          left: 0,
          objectFit: 'cover',
          background: '#fff',
          backdropFilter: 'blur(1px)',
          // mixBlendMode: 'multiply',
        }}
      />
      <div
        style={{
          position: 'relative',
          // top: isMobile ? '-160px' : 0,
          width: '100%',
          height: 440,
          display: 'flex',
          flexDirection: 'column',
          gap: 5,
          justifyContent: 'center',
          alignItems: 'center',
          // backgroundColor: 'black',
        }}
      >
        <Box
          sx={{
            background: '#fff',
            padding: '12px',
            width: isMobile ? '95vw' : 'max(60vw, 300px)',
            borderRadius: 2,
            // filter: 'drop-shadow(0 4px 40px #555)',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#222',
              borderWidth: 3,
            },
            '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
              color: '#222',
              fontWeight: 800,
            },
            // animation: 'outline-pulse 2s infinite normal',
          }}
          onClick={() => {
            isMobile && setIsMobileSearchModalOpen(true);
          }}
        >
          {!isMobileSearchModalOpen && SearchBox(true)}
        </Box>

        {/* <Grid
          container
          sx={{
            // background: 'blue',
            padding: '10px',
            width: isMobile ? '95vw' : 'max(60vw, 300px)',
            borderRadius: 2,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Grid item xs={8} sx={{ paddingRight: '5px' }}>
            <Typography sx={{ fontWeight: '500px', fontSize: '16px' }}>
              {' '}
              Explore the Best Short-Term Rental Markets with{' '}
              <span style={{ color: COLOR_PRIMARY_1, fontWeight: '500px' }}>High ROI</span>
            </Typography>
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Button
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: COLOR_PRIMARY_1,
                color: '#fff',
                borderRadius: '10px',
                fontSize: '12px',
                gap: 1,
                '&:hover': {
                  color: '#fff',
                  background: COLOR_PRIMARY_2,
                },
                paddingLeft: 2,
                paddingRight: 2,
              }}
              onClick={() => {
                localStorage.setItem('openDiscovery', 'true');
                history.push('/markets/' + userCountryCode.toUpperCase());
                return;
              }}
            >
              <Typography sx={{ fontSize: '16px' }}>Discover Markets with AI</Typography>
              <AutoAwesomeIcon />
            </Button>
          </Grid>
        </Grid> */}
      </div>

      {isMobileSearchModalOpen && (
        <Modal
          open={isMobileSearchModalOpen}
          onClose={() => {
            setIsMobileSearchModalOpen(false);
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
              background: '#fff',
              width: '100vw',
              height: '100%',
              zIndex: 7000,
            }}
          >
            <Box sx={{ margin: '10px', display: 'flex' }}>
              <Grid container spacing={1}>
                <Grid item xs={11}>
                  {SearchBox(true)}
                </Grid>
                <Grid item xs={1} sx={{ display: 'flex', alignItems: 'center' }}>
                  <CloseRoundedIcon
                    sx={{ fontSize: '30px', color: COLOR_GREY_600 }}
                    onClick={() => setIsMobileSearchModalOpen(false)}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Modal>
      )}
    </>
  );
};

const Card = ({
  title,
  icon,
  invert,
  onClickAction,
}: {
  title: string;
  icon: JSX.Element;
  invert: boolean;
  onClickAction: () => void;
}) => {
  return (
    <Grid
      item
      container
      justifyContent={'center'}
      alignItems={'center'}
      direction={'column'}
      style={{
        height: '140px',
        width: '300px',
        padding: 0,
        background: invert ? '#fff' : COLOR_PRIMARY_DARK,
        color: invert ? COLOR_PRIMARY_DARK : '#fff',
        borderRadius: 4,
        filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
        cursor: 'pointer',
      }}
      onClick={onClickAction}
    >
      <Grid item justifyContent={'center'} alignItems={'center'}>
        {icon}
      </Grid>
      <Grid item justifyContent={'center'} alignItems={'center'}>
        <Typography variant="h6">{title}</Typography>
      </Grid>
    </Grid>
  );
};

export default IndividualOnBoardingPage;
